import { createContext, useState, useContext, ReactNode, FC } from "react";

interface ContexteProps {
  isBurgerMenuOpened: boolean;
  toggleMenu: () => void;
}

const MenuContext = createContext<ContexteProps | undefined>(undefined);

interface MenuProviderProps {
  children: ReactNode;
}

export const MenuProvider: FC<MenuProviderProps> = ({ children }) => {
  const [isBurgerMenuOpened, setIsBurgerMenuOpened] = useState(false);

  const toggleMenu = () => {
    setIsBurgerMenuOpened(!isBurgerMenuOpened);
  };

  return (
    <MenuContext.Provider value={{ isBurgerMenuOpened, toggleMenu }}>
      {children}
    </MenuContext.Provider>
  );
};

export const useMenu = () => {
  const context = useContext(MenuContext);
  if (context === undefined) {
    throw new Error("useMenu doit être utilisé dans un MenuProvider");
  }
  return context;
};
